var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxBxCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.772 10.156L19.404 6.051C19.2056 5.45348 18.8238 4.9337 18.3131 4.56551C17.8024 4.19732 17.1886 3.99944 16.559 4H7.441C6.81139 3.99944 6.19761 4.19732 5.68688 4.56551C5.17615 4.9337 4.79445 5.45348 4.596 6.051L3.228 10.156C2.86461 10.3085 2.55428 10.5648 2.33584 10.8928C2.11741 11.2208 2.00059 11.6059 2 12V17C2 17.753 2.423 18.402 3.039 18.743C3.026 18.809 3 18.869 3 18.938V21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22H5C5.26522 22 5.51957 21.8946 5.70711 21.7071C5.89464 21.5196 6 21.2652 6 21V19H18V21C18 21.2652 18.1054 21.5196 18.2929 21.7071C18.4804 21.8946 18.7348 22 19 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V18.938C21 18.869 20.974 18.808 20.961 18.743C21.2744 18.5721 21.5362 18.3202 21.7189 18.0136C21.9017 17.707 21.9988 17.357 22 17V12C22 11.171 21.492 10.459 20.772 10.156ZM4 17V12H20L20.002 17H4ZM7.441 6H16.558C16.989 6 17.371 6.274 17.507 6.684L18.613 10H5.387L6.492 6.684C6.55835 6.4848 6.68572 6.31153 6.85605 6.18876C7.02638 6.06599 7.23104 5.99995 7.441 6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16C7.32843 16 8 15.3284 8 14.5C8 13.6716 7.32843 13 6.5 13C5.67157 13 5 13.6716 5 14.5C5 15.3284 5.67157 16 6.5 16Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16C18.3284 16 19 15.3284 19 14.5C19 13.6716 18.3284 13 17.5 13C16.6716 13 16 13.6716 16 14.5C16 15.3284 16.6716 16 17.5 16Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxCar);
export default __webpack_public_path__ + "static/media/bx_bx-car.1ca483554368c7b3874478814a6b5d8f.svg";
export { ForwardRef as ReactComponent };